import React, { useContext } from "react";
import { ToastContext } from "../context/toast";

const ToastMessage = () => {
  const { visible } = useContext(ToastContext);

  return (
    <div className={`toast-message ${visible && "visible"}`}>
      <h2>Code copied to clipboard</h2>
    </div>
  );
};

export default ToastMessage;
